export const nlDateToIsoDate = date => {
  date = date ? date : '';
  return date.split('-').reverse().join('-');
}

export const createDateObj = date => {
  return new Date(date + 'T00:00:00.000Z');
}

export const makeNLDate = dateObj => {
  return dateObj.toLocaleDateString('nl-NL', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}